import { Component, input, output } from '@angular/core';
import { CardGridItem } from '../../models';

@Component({
  selector: 'app-card-grid',
  templateUrl: './card-grid.component.html',
  styleUrl: './card-grid.component.scss',
})
export class CardGridComponent {
  public readonly items = input<CardGridItem[]>([]);
  public readonly title = input<string>();
  public readonly showCreate = input(true);
  public readonly showDelete = input(true);
  public readonly minCardWidth = input(220);

  public readonly cardClick = output<CardGridItem>();
  public readonly create = output<void>();
  public readonly delete = output<CardGridItem>();
}
